<template>
  <div class="add-card">
    <xl-dialog
      :title="$t('design.creditCard.addCard') || '新增信用卡'"
      v-model="visible"
      width="712px"
      @close="close"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="steps-container">
        <!-- 步骤条 -->
        <xl-steps :active="active" finish-status="success" simple>
          <xl-step :title="$t('design.creditCard.baseInfo') || '基本信息'">
            <template #icon>
              <img
                v-if="active === 0"
                src="../../assets/image/step_one_active.svg"
                alt=""
              />
              <img v-else src="../../assets/image/step_success.svg" alt="" />
            </template>
          </xl-step>
          <xl-step
            :title="$t('design.creditCard.billingAddress') || '账单地址'"
          >
            <template #icon>
              <img
                v-if="active === 1"
                src="../../assets/image/step_two_active.svg"
                alt=""
              />
              <img v-else src="../../assets/image/step_two.svg" alt="" />
            </template>
          </xl-step>
        </xl-steps>
      </div>
      <!-- 步骤1 基本信息 -->
      <div v-if="!active" class="base-info-step">
        <xl-form
          ref="baseFormRef"
          :model="baseInfo"
          :rules="baseRules"
          label-position="top"
          show-message
        >
          <xl-row :gutter="20">
            <xl-col :span="12">
              <xl-form-item
                prop="cardChannel"
                :label="$t('design.creditCard.cardType') || '信用卡类型'"
              >
                <xl-radio-group v-model="baseInfo.cardChannel">
                  <xl-radio label="Visa" size="large" border>
                    <div>
                      <div class="radio-label">VISA</div>
                      <img src="../../assets/image/visa.svg" alt="" />
                    </div>
                  </xl-radio>
                  <xl-radio label="Mastercard" size="large" border>
                    <div>
                      <div class="radio-label">Master card</div>
                      <img src="../../assets/image/master_card.svg" alt="" />
                    </div>
                  </xl-radio>
                </xl-radio-group>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item prop="card" label="">
                <div class="card-info-box" :class="{ 'cvv-info-box': showCVV }">
                  <!-- 卡号信息页 -->
                  <div v-if="!showCVV">
                    <img src="../../assets/image/chip-icon.svg" alt="" />
                    <div class="card-number">
                      <div class="number-box" v-for="(i, index) in 16" :key="i">
                        <img
                          v-show="index >= cardNumberList?.length"
                          src="../../assets/image/dot-icon.svg"
                          alt=""
                        />
                        <div
                          class="number-text"
                          v-show="index < cardNumberList?.length"
                        >
                          {{ cardNumberList[index] }}
                        </div>
                      </div>
                    </div>
                    <div class="card-info">
                      <div class="info-text">
                        <span class="name-text">{{
                          baseInfo.cardOwner
                            ? baseInfo.cardOwner
                            : $t("design.creditCard.yourName") || "你的名字"
                        }}</span>
                      </div>
                      <div class="expiration-date">
                        <div class="info-text">
                          {{
                            $t("design.creditCard.effectiveDate") || "有效期"
                          }}
                        </div>
                        <div class="info-text">
                          {{
                            baseInfo.expirationDate
                              ? baseInfo.expirationDate?.split("-")[1] +
                                "/" +
                                baseInfo.expirationDate?.split("-")[0]
                              : "xx/xx"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- cvv页 -->
                  <div v-else>
                    <div class="line-box"></div>
                    <div class="cvv-info">{{ baseInfo.cvc }}</div>
                  </div>
                </div>
                <div></div>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="cardOwner"
                :label="$t('design.creditCard.name') || '姓名'"
              >
                <xl-input
                  v-model="baseInfo.cardOwner"
                  :placeholder="
                    $t('design.creditCard.inputName') || '请输入姓名'
                  "
                  @focus="showCVV = false"
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="cardNum"
                :label="$t('design.creditCard.cardNumber') || '卡号'"
              >
                <xl-input
                  v-model="baseInfo.cardNum"
                  :placeholder="
                    $t('design.creditCard.inputCardNumber') || '请输入卡号'
                  "
                  :maxlength="16"
                  @focus="showCVV = false"
				  @change="handelCardNumChange"
				  @input="baseInfo.cardNum = baseInfo.cardNum.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="expirationDate"
                :label="
                  $t('design.creditCard.effectiveDateTo', {
                    date: baseInfo.expirationDate
                      ? baseInfo.expirationDate?.split('-')[1] +
                        '/' +
                        baseInfo.expirationDate?.split('-')[0]
                      : $t('design.creditCard.monthYear'),
                  })
                "
              >
                <xl-date-picker
                  style="width: 100%"
                  v-model="baseInfo.expirationDate"
                  type="month"
                  :placeholder="
                    $t('design.creditCard.selectDate') || '请选择日期'
                  "
                  :disabled-date="disabledMonth"
                  @focus="showCVV = false"
                  value-format="YYYY-MM"
                />
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="cvc"
                :label="
                  $t('design.creditCard.inputCardCode') ||
                  'CVV（请输入后三位安全验证码）'
                "
              >
                <xl-input
                  v-model="baseInfo.cvc"
                  :placeholder="$t('design.creditCard.inputCVV') || '请输入CVV'"
                  :maxlength="3"
                  @focus="showCVV = true"
				  @input="baseInfo.cvc = baseInfo.cvc.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                class="default-box"
                prop="isDefault"
                :label="
                  $t('design.creditCard.defaultPayment') || '设为默认支付'
                "
              >
                <xl-switch
                  v-model="baseInfo.isDefault"
                  active-value="y"
                  inactive-value="n"
				          :disabled="!$getLocalStorage('hasDefaultCard')"
                ></xl-switch>
              </xl-form-item>
            </xl-col>
          </xl-row>
        </xl-form>
      </div>
      <!-- 步骤2 账单地址 -->
      <div v-if="active === 1" class="step-two">
        <xl-form
          ref="addressFormRef"
          :model="addressInfo"
          :rules="addressRules"
          label-position="top"
          show-message
        >
          <xl-row :gutter="20">
            <xl-col :span="12">
              <xl-form-item
                prop="address1"
                :label="$t('design.creditCard.billAddress1') || '地址1'"
              >
                <xl-input
                  v-model="addressInfo.address1"
                  :placeholder="
                    $t('design.creditCard.inputAddress') || '请输入地址'
                  "
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="address2"
                :label="$t('design.creditCard.billAddress2') || '地址2'"
              >
                <xl-input
                  v-model="addressInfo.address2"
                  :placeholder="
                    $t('design.creditCard.inputAddress') || '请输入地址'
                  "
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="country"
                :label="$t('design.creditCard.billCountry') || '国家'"
              >
                <xl-select
                  class="select-width"
                  v-model="addressInfo.country"
                  :placeholder="
                    $t('design.creditCard.selectCountry') || '请选择地区'
                  "
				  :options="$store.state.countryList"
				  filterable
				  @change="handleCountryChange"
                ></xl-select>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="state"
                :label="$t('design.creditCard.billState') || '省/州'"
              >
                <xl-select
                  class="select-width"
                  v-model="addressInfo.state"
                  :placeholder="
                    $t('design.creditCard.selectState') || '请选择省/州'
                  "
                ></xl-select>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="city"
                :label="$t('design.creditCard.billCity') || '市'"
              >
              <xl-input v-model="addressInfo.city" :placeholder="$t('design.creditCard.inputCity') || '请输入市'"></xl-input>
                <!-- <xl-select
                  class="select-width"
                  v-model="addressInfo.city"
                  :placeholder="
                    $t('design.creditCard.selectCity') || '请选择市'
                  "
                ></xl-select> -->
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="postalCode"
                :label="$t('design.creditCard.billPostalCode') || '邮政编码'"
              >
                <xl-input
                  v-model="addressInfo.postalCode"
                  :placeholder="
                    $t('design.creditCard.inputPostalCode') || '请输入邮政编码'
                  "
				   @input="addressInfo.postalCode = addressInfo.postalCode.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"
                ></xl-input>
              </xl-form-item>
            </xl-col>
          </xl-row>
        </xl-form>
      </div>
      <template #footer>
        <div class="footer-button">
          <xl-button v-if="!active" @click="close">{{
            $t("design.cancel") || "取消"
          }}</xl-button>
          <xl-button v-if="active" @click="goBack">{{
            $t("design.goBack") || "上一步"
          }}</xl-button>
          <xl-button v-if="active !== 1" type="primary" @click="goNext">{{
            $t("design.goNext") || "下一步"
          }}</xl-button>
          <xl-button v-if="active === 1" type="primary" @click="handleSubmit">{{
            $t("design.confirm") || "确定"
          }}</xl-button>
        </div>
      </template>
    </xl-dialog>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits, watch, onMounted } from "vue";
import {
  XlDialog,
  XlButton,
  XlSteps,
  XlStep,
  XlForm,
  XlFormItem,
  XlRow,
  XlCol,
  XlRadioGroup,
  XlRadio,
  XlInput,
  XlInputNumber,
  XlDatePicker,
  XlSwitch,
  XlSelect,
  XlMessage
} from "@shining3d/ui-components";
import { cloneDeep } from "lodash";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import creditCardApi from "../../api/creditCard";
import { useStore } from "vuex";
import { $getLocalStorage, $setLocalStorage } from '@shining3d/common-module/utils/index.js';
import _get from 'lodash/get';

const $store = useStore();
const { $t } = useLang("@shining3d/xl-design-order");
const emit = defineEmits(['getCardList', 'getDefaultCard']);
const visible = ref(false);
const close = () => {
  visible.value = false;
};
const init = () => {
  baseInfo.value = cloneDeep( initBaseInfo );
  addressInfo.value = cloneDeep( initAddressInfo );
  active.value = 0;
}
const show = () => {
  init();
  visible.value = true;
};
const active = ref(0);
const initBaseInfo = {
  cardType: "credit",
  cardChannel: "",
  cardOwner: "",
  cardNum: "",
  expirationDate: "",
  cvc: "",
  isDefault: $getLocalStorage('hasDefaultCard') ? 'n' : 'y',
};
const baseInfo = ref(cloneDeep(initBaseInfo));
const baseFormRef = ref();
const baseRules = {
  cardChannel: [
    {
      required: true,
      message: $t("design.creditCard.cardTypeRequire") || "信用卡类型不能为空",
      trigger: "change",
    },
  ],
  cardOwner: [
    {
      required: true,
      message: $t("design.creditCard.nameRequire") || "姓名不能为空",
      trigger: "blur",
    },
  ],
  cardNum: [
    {
      required: true,
      message: $t("design.creditCard.cardNumberRequire") || "卡号不能为空",
      trigger: "blur",
    },
  ],
  expirationDate: [
    {
      required: true,
      message: $t("design.creditCard.effectiveDateRequire") || "有效期不能为空",
      trigger: "change",
    },
  ],
  cvc: [
    {
      required: true,
      message: $t("design.creditCard.CVVRequire") || "CVV不能为空",
      trigger: "blur",
    },
  ],
  isDefault: [
    {
      required: true,
      message:
        $t("design.creditCard.isDefaultRequire") || "是否设为默认不能为空",
      trigger: "change",
    },
  ],
};
// 账单数据
const initAddressInfo = {
  address1: "",
  address2: "",
  country: "",
  state: "",
  city: "",
  postalCode: "",
};
const addressInfo = ref(cloneDeep(initAddressInfo));
const addressFormRef = ref();
const addressRules = {
  address1: [
    {
      required: true,
      message: $t("design.creditCard.addressRequire") || "地址不能为空",
      trigger: "blur",
    },
  ],
  country: [
    {
      required: true,
      message: $t("design.creditCard.billCountryRequire") || "地区不能为空",
      trigger: "change",
    },
  ],
  state: [
    {
      required: true,
      message: $t("design.creditCard.billStateRequire") || "省/州不能为空",
      trigger: "change",
    },
  ],
};
const cardNumberList = computed(() => baseInfo.value.cardNum?.split(""));
const showCVV = ref(false);
// 禁用当前日期之前的日期
const disabledMonth = (time) => {
  return time.getTime() < Date.now();
};

const goBack = () => {
  active.value -= 1;
};
const goNext = () => {
  baseFormRef.value.validate((valid) => {
    if (valid) {
      active.value += 1;
    }
  });
};
// 输入卡号变化时校验卡类型
const handelCardNumChange = () => {
	baseInfo.value.cardChannel = '';
	if(/^4[0-9]{12}(?:[0-9]{3})?$/.test(baseInfo.value.cardNum)){
		baseInfo.value.cardChannel = 'Visa';
	} else if(/^5[1-5][0-9]{14}$/.test(baseInfo.value.cardNum)){
		baseInfo.value.cardChannel = 'Mastercard';
	}
}
// 修改国家 获取国家对应的省/州
const handleCountryChange = () => {
	creditCardApi.getArea({country: addressInfo.value.country}).then((res) => {
		if( res && res.status === 'success' ){

		}
	})
}
defineExpose({ show });
// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
// 提交绑定
const handleSubmit = () => {
	const data = {
    	...baseInfo.value,
        expiryYear: baseInfo.value.expirationDate?.split("-")[0],
        expiryMonth: baseInfo.value.expirationDate?.split("-")[1],
        platform: window.app?.entryName || 'dental',
        businessID: institutionId,
        extra: JSON.stringify(addressInfo.value),
    }
	
//   addressFormRef.value.validate((valid) => {
    // if (valid) {
      creditCardApi
        .addPayCard({
			param: JSON.stringify(data)
        })
        .then((res) => {
          if ( res && res.status === "success") {
			XlMessage({
				type: 'success',
				message: $t('design.creditCard.addCardSuccess') || '添加信用卡成功'
			});
			visible.value = false;
			emit('getCardList');
			emit('getDefaultCard');
          }
        });
    // }
//   });
};
// onMounted(() => {
// 	if($getLocalStorage('hasDefaultCard')){
// 		baseInfo.value.isDefault = 'n';
// 	} else {
// 		baseInfo.value.isDefault = 'y';
// 	}
// });
</script>

<style lang="scss" scoped>
.add-card {
  .base-info-step {
    :deep(.el-radio) {
      width: 124px;
      height: 110px;
      padding: 8px 12px 12px 12px;
      border-radius: 6px;
      margin-right: 16px;
      .el-radio__input {
        position: absolute;
        right: 10px;
        top: 12px;
      }
      .el-radio__label {
        padding: 0;
      }
    }
    :deep(.el-radio.is-bordered.is-checked) {
      background: #edf3ff;
    }
    .radio-label {
      width: 31px;
      height: 22px;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: #42526e;
      margin-bottom: 4px;
    }
    .card-info-box {
      width: 248px;
      height: 140px;
      border-radius: 10px;
      background: #a5a9ad;
      padding: 18px;
      box-sizing: border-box;
      .card-number {
        height: 22px;
        font-size: 14px;
        font-weight: 700;
        line-height: 22px;
        margin: 12px 0;
        color: #ffffff;
      }
      .card-info {
        display: flex;
        justify-content: space-between;
        .info-text {
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          text-align: right;
          color: #ffffff;
        }
        .name-text {
          padding-top: 18px;
          display: inline-block;
          max-width: 120px;
          overflow: hidden;
          white-space: nowrap;
        }
        .expiration-date {
          max-width: 80px;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
    .cvv-info-box {
      padding: 0 !important;
      .line-box {
        width: 248px;
        height: 32px;
        margin: 15px 0 8px 0;
        background: #6c7074;
      }
      .cvv-info {
        width: 165px;
        height: 31px;
        padding-right: 4px;
        margin-left: 12px;
        text-align: right;
        background-image: url("../../assets/image/cvv_bg.svg");
      }
    }
    .default-box {
      display: flex !important;
      align-items: center;
      :deep(.el-form-item__label) {
        margin-bottom: 0;
      }
    }
  }
  :deep(.el-steps--simple) {
    background: transparent;
    padding: 0 25% 16px 25%;
  }
  :deep(.el-step.is-simple .el-step__arrow::before) {
    width: 1px;
    height: 7px;
    background: #42526e;
    transform: rotate(-45deg) translateY(-2px);
  }
  :deep(.el-step.is-simple .el-step__arrow::after) {
    width: 1px;
    height: 7px;
    background: #42526e;
    transform: rotate(45deg) translateY(2px);
  }
  :deep(.el-step.is-simple .el-step__title) {
    font-size: 14px;
    font-weight: 700;
    line-height: 48px;
    padding-right: 16px;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
  }
  :deep(.el-step__title.is-wait) {
    color: #42526e;
  }
  :deep(.el-step__title.is-process) {
    color: #5587ff;
  }
  :deep(.el-step__title.is-success) {
    color: #42526e;
  }
  :deep(.el-step__head.is-success) {
    .el-step__icon.is-text {
      width: 16px;
      height: 16px;
      border: 0;
      display: inline-block;
      background-image: url("../../assets/image/step_success.svg");
      background-size: contain;
      svg {
        height: 0;
      }
    }
    .el-step__icon.is-icon {
      background-image: url("../../assets/image/step_success.svg");
    }
  }
  :deep(.el-step__title.is-process) {
    border-bottom: 2px solid #5587ff;
  }
  :deep(.el-step__head) {
    padding: 16px;
  }
  :deep(.el-step__head.is-process) {
    border-bottom: 2px solid #5587ff;
  }
  .step-two {
    height: 408px;
    .select-width {
      width: 322px;
    }
  }
  .card-number {
    display: flex;
    .number-box {
      margin-right: 2.5px;
      &:nth-child(4n) {
        margin-right: 12px !important;
      }
      .number-text {
        width: 9px;
      }
    }
  }
  :deep(.el-input--large.el-input--prefix .el-input__inner) {
    padding-left: 11px;
  }
}
</style>
